import type { FC } from "react";
import {
    SectionWrapper,
    StyledBox,
} from "app/pages/website-analysis/analyze-publishers/monetization-networks/StyledComponents";
import { AdsTrafficContainer } from "app/pages/website-analysis/analyze-publishers/common/ads-traffic/AdsTrafficContainer";
import { TotalVisits } from "app/pages/website-analysis/analyze-publishers/common/total-visits/TotalVisits";
import { MonetizationNetworksTable } from "./monetization-networks-table/MonetizationNetworksTable";
import { useCurrentStateAndParams } from "@uirouter/react";
import { chosenSites } from "app/common/services/chosenSites";
import { NewSectionBanner } from "../advertisers/AdvertisersContainer";

export const MonetizationNetworksContainer: FC = () => {
    const { params } = useCurrentStateAndParams();
    const isSingle = params.key.split(",").length === 1;
    const chosenItems = chosenSites.sitelistForLegend();
    return (
        <>
            <NewSectionBanner />
            <SectionWrapper>
                {isSingle && (
                    <StyledBox
                        height={"340px"}
                        minWidth={"295px"}
                        width={"33%"}
                        marginRight={"24px"}
                        data-automation="totalVisits"
                    >
                        <TotalVisits isMonetizationPage={true} />
                    </StyledBox>
                )}
                <StyledBox
                    height={"340px"}
                    minWidth={"575px"}
                    width={isSingle ? "66%" : "100%"}
                    data-automation="adsTraffic"
                >
                    <AdsTrafficContainer
                        chosenItems={chosenItems}
                        isMonetizationPage={true}
                    />
                </StyledBox>
            </SectionWrapper>
            <SectionWrapper>
                <MonetizationNetworksTable />
            </SectionWrapper>
        </>
    );
};
